import { FC } from 'react'
import styled from 'styled-components'

type AvatarProps = {
  size: number
}
export const Avatar: FC<AvatarProps> = (props) => {
  const { size } = props
  return (
    <Wrap size={size}>
      <img src="/navigater.png" alt="" />
    </Wrap>
  )
}

const Wrap = styled.div<AvatarProps>`
  font-size: 10px;
  border-radius: 50%;
  overflow: hidden;
  font-weight: 10;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: ${({ size }) => `${size}px`};
  width: ${({ size }) => `${size}px`};

  img {
    width: 100%;
  }
`
